module.exports = __webpack_public_path__ + "media/images/default/pages/depth_views/line-orange-86418fe780c594adb916020c3fe016ca.svg";